export const Perfis = {
  CADASTRAR_PERFIL: "Register new profile",
  CONFIRMAR_EXCLUIR: "Are you sure you want to delete this profile",
  NOME: "Name",
  PERFIS: 'Profiles',
  PERFIS_DESCRICAO: 'On this screen, you can manage profiles.',
  PERFIL_CADASTRADO_SUCESSO: "Profile successfully registered",
  PERFIL_EXCLUIDO_SUCESSO: "Profile deleted successfully",
  RESTRINGIR_PAINEL_PROFESSOR: "Restrict Teacher Dashboard",
};
